import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type onDropdownClosedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
};

export const onDropdownClosed = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: onDropdownClosedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: `${ACTION_SUBJECT_PREFIX}Dropdown`,
	action: 'closed',
	attributes: {
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
